
import * as React from 'react';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';

/**
 * @public
 */
export interface IGetDownloadData {
    url: string;
    method: 'GET';
}

/**
 * @public
 */
export interface IPostDownloadData {
    url: string;
    method: 'POST';
    postData: { [key: string]: string; };
}

/**
 * @public
 */
export type IDownloadData = IGetDownloadData | IPostDownloadData;

/**
 * @public
 */
export interface IDownloaderProps {
    resolve: () => void;
    reject: (error: Error) => void;
    itemKeys: string[];
    getDownloadData: () => Promise<IDownloadData>;
    preferOpenInBrowser?: boolean;
}

/**
 * @public
 */
export interface IDownloadItemsActionControlProps {
    itemKeys: string[];
}

/**
 * @public
 */
export interface IDownloadItemsActionControlOverrides {
    isAvailable: boolean;
    downloader: React.ComponentType<IComponentAsProps<IDownloaderProps>>;
    getDownloadData: () => IItemCacheThunkAction<Promise<IDownloadData>>;
}

/**
 * @public
 */
export const downloadItemsActionControlFacet:
    ControlFacet<IDownloadItemsActionControlProps, IDownloadItemsActionControlOverrides> =
    new ControlFacet<IDownloadItemsActionControlProps, IDownloadItemsActionControlOverrides>('downloadItemsActionControl', {
        downloader: defaultRenderComponentOption()
    });
